import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useAuth } from '../contexts/AuthContext';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  
  useEffect(() => {
    const attemptLogin = async () => {
      try {
        // Check if we have temporary auth credentials
        const email = localStorage.getItem('tempAuthEmail');
        const password = localStorage.getItem('tempAuthPassword');
        
        if (email && password) {
          // Try to login with stored credentials
          const success = await login(email, password);
          
          if (success) {
            // Clear temporary credentials
            localStorage.removeItem('tempAuthEmail');
            localStorage.removeItem('tempAuthPassword');
            
            // Redirect to dashboard after successful login
            setTimeout(() => {
              navigate('/dashboard');
              setLoading(false);
            }, 2000);
            return;
          }
        }
        
        // If we reach here, either no credentials or login failed
        if (isAuthenticated) {
          setTimeout(() => {
            navigate('/dashboard');
            setLoading(false);
          }, 2000);
        } else {
          setTimeout(() => {
            navigate('/login');
            setLoading(false);
          }, 2000);
        }
      } catch (error) {
        setErrorMessage('Error logging in. Please try to login manually.');
        setLoading(false);
      }
    };
    
    attemptLogin();
  }, [isAuthenticated, navigate, login]);
  
  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', py: 8 }}>
      <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main' }} />
      <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
        Payment Successful!
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Thank you for your payment. Your account has been activated.
      </Typography>
      
      {errorMessage && (
        <Typography variant="body2" color="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Typography>
      )}
      
      <Typography variant="body2" sx={{ mb: 2 }}>
        {loading ? (
          <>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            {isAuthenticated ? 'Redirecting to your dashboard...' : 'Signing you in...'}
          </>
        ) : (
          <>
            {isAuthenticated ? 
              'Redirecting to your dashboard...' : 
              'Please log in to access your account.'
            }
          </>
        )}
      </Typography>
      
      {!loading && !isAuthenticated && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/login')}
        >
          Log In
        </Button>
      )}
    </Container>
  );
};

export default PaymentSuccess; 